var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlaylist = function SvgPlaylist(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5 1.25a.75.75 0 0 0 0 1.5h14a.75.75 0 0 0 0-1.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M17.25 8a.75.75 0 0 0-.944-.725l-6.43 1.72a.75.75 0 0 0-.556.725v5.254l-1.56.412a2.026 2.026 0 0 0 1.032 3.917l.326-.086a2.285 2.285 0 0 0 1.702-2.21v-6.711l4.93-1.319v4.271l-1.571.423a2.025 2.025 0 0 0 1.042 3.912l.327-.086a2.285 2.285 0 0 0 1.702-2.21zm-9.108 8.836 1.178-.31v.482c0 .356-.24.668-.585.759l-.325.085a.526.526 0 0 1-.268-1.016m6.426-1.717 1.182-.317v.486c0 .356-.24.668-.585.759l-.327.086a.525.525 0 0 1-.27-1.014",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4 4.25A1.75 1.75 0 0 0 2.25 6v15c0 .966.784 1.75 1.75 1.75h16A1.75 1.75 0 0 0 21.75 21V6A1.75 1.75 0 0 0 20 4.25zM3.75 6A.25.25 0 0 1 4 5.75h16a.25.25 0 0 1 .25.25v15a.25.25 0 0 1-.25.25H4a.25.25 0 0 1-.25-.25z",
    clipRule: "evenodd"
  })));
};
export default SvgPlaylist;